<template>
  <v-app id="app">
    <router-view></router-view>
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="snackbarColor"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      <span v-html="snackbarText"></span>

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <Loader :loading="wait"></Loader>
    <v-btn id="ribbon" fixed @click="open = true" justify-end v-if="$store.getters.roles">
      Send feedback
    </v-btn>
    <v-dialog persistent v-model="open" class="opa" max-width="800">
      <v-card
        class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8 rounded-xl secondaryBackground"
      >
        <v-card-title class="pb-3 pb-sm-10 pb-lg-10 pb-xl-10 pb-md-10">
          <v-row>
            <v-col sm="12" class="justify-center d-flex">
              <img
                alt="Logo"
                width="180"
                class="rounded-0 text-center"
                :src="require('@/assets/svg/logo.svg')"
              />
            </v-col>
          </v-row>
          <v-btn icon @click="open = false" left>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="pb-2 pb-sm-10 pb-md-10 pb-lg-10 pb-xl-10"></v-divider>
        <v-card-text>
          <v-layout row wrap align-center>
            <v-flex>
              <v-form ref="form" :lazy-validation="false">
                <v-row class="justify-center" v-if="errorSummary !== null">
                  <v-col col="12" md="10" xl="10" lg="10" sm="12" class="pb-0">
                    <v-alert
                      class="error"
                      id="error"
                      type="info"
                      dense
                      icon="mdi-information-outline"
                      >{{ errorSummary }}
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row class="justify-center">
                  <v-col cols="12">
                    Please provide your feedback below:
                  </v-col>
                  <v-col cols="12">
                    <label class="text-bold subtitle-2">Summary</label>
                    <v-text-field
                      class="pt-2"
                      v-model="request.summary"
                      :placeholder="'Summary'"
                      outlined
                      required
                      :rules="requiredRule()"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <label class="text-bold subtitle-2">Description</label>
                    <v-textarea
                      v-model="request.description"
                      outlined
                      class="required"
                      data-cy="description"
                      :rules="requiredRule()"
                      :placeholder="'Your description here'"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <label class="text-bold subtitle-2">Full Name</label>
                    <v-text-field
                      class="pt-2"
                      v-model="request.name"
                      :placeholder="'Full Name'"
                      outlined
                      required
                      :rules="requiredRule()"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <label class="text-bold subtitle-2">{{ $t('email') }}</label>
                    <v-text-field
                      class="pt-2"
                      v-model="request.email"
                      :placeholder="$t('email')"
                      outlined
                      required
                      :rules="emailRules()"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row class="justify-center">
                  <v-col
                    col="12"
                    md="5"
                    xl="5"
                    lg="5"
                    sm="12"
                    class="d-flex pt-1 pt-sm-7 pt-xl-7 pt-md-7 pt-lg-7 align-center"
                  >
                    <v-btn
                      large
                      class="rounded-lg pl-10 pr-10 white--text change-button"
                      color="neutral"
                      block
                      :disabled="!request"
                      @click="sendFeedback()"
                      >{{ $t('submit') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import Loader from '@/components/shared/helpers/Loader.vue';
import util from '@/mixins/util';

export default {
  name: 'App',
  components: {
    Loader,
  },
  mixins: [util],
  data() {
    return {
      snackbar: false,
      snackbarColor: '',
      mode: '',
      snackbarText: '',
      timeout: 6000,
      x: null,
      y: 'bottom',
      wait: false,
      errorSummary: null,
      request: {
        name: null,
        summary: null,
        description: null,
        email: null,
      },
      open: false,
    };
  },
  created() {
    EventBus.$on('snackbar', this.snackbarChanged);
    EventBus.$on('waiting', this.waiting);
    if (
      localStorage.getItem('roles') != null &&
      !(localStorage.getItem('roles') === 'default-roles-quarkus')
    ) {
      this.axios.put(`api/v1/users/last-login`).then(() => {
        console.debug('Last login updated successfully');
      });
    }
  },
  beforeDestroy() {
    EventBus.$off('snackbar', this.snackbarChanged);
    EventBus.$off('waiting', this.waiting);
  },
  methods: {
    snackbarChanged(params) {
      this.snackbarText = params.text;
      this.snackbarColor = params.color;
      this.timeout = params.timeout || 4000;
      this.snackbar = true;
    },
    waiting(value) {
      this.wait = value;
    },
    sendFeedback() {
      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/email/send-request', this.request)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('feedback-successfully'),
          });
          this.open = false;
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
  },
};
</script>

<style>
#ribbon {
  right: 0;
  height: 135px;
  min-width: 35px;
  bottom: 45%;
  padding: 0;
  background: #a870ff;
  border: 2px solid #d4b8ff;
  border-radius: 16px 0px 0px 16px;
  color: white;
  z-index: 200;
}

#ribbon .v-btn__content {
  writing-mode: vertical-rl;
  font-size: 12px;
}

.on-hover-underline:hover {
  text-decoration: underline !important;
}

a.v-breadcrumbs__item:hover {
  text-decoration: underline;
}

.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: 25px !important;
}
</style>
